var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M28.06 16.507c-.025-.038-.061-.072-.097-.106q-.013-.023-.027-.043c-.019-.046-.036-.091-.067-.134l-3.581-7.572a8.57 8.57 0 0 0-6.655-5.057c-.255-1.085-1.495-1.777-2.847-1.553-1.354.223-2.306 1.278-2.197 2.387a8.58 8.58 0 0 0-4.672 6.934l-.951 8.319c-.017.05-.018.099-.02.147q-.007.025-.013.05c-.022.044-.047.09-.057.133l-2.679 6.23c-.16.286-.228.567-.183.836.348 2.1 7.128 2.727 15.144 1.401s14.234-4.104 13.887-6.204c-.045-.269-.198-.513-.442-.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    d: "M33.045 22.275c.347 2.1-5.87 4.878-13.887 6.203-8.016 1.327-14.796.7-15.143-1.4S9.883 22.2 17.9 20.874c8.015-1.327 14.796-.7 15.144 1.401"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    d: "M20.983 28.397a4.816 4.816 0 1 1-9.504 1.57 4.816 4.816 0 0 1 9.504-1.57"
  }))));
};
export default SvgNotification;